// @ts-strict-ignore
import type { dashboardApiEndpoints, GetUseQueryOptions, ExtractTheDefinedEndpoints } from "@dashboardApi/apis";

import { useCompany } from "@services/useCompany";
import { useDashboardApiQuery } from "@services/useDashboardApi";

export const useCompaniesCompanyIdDevelopersCurrentApiQuery = <
  TFnData = Awaited<
    ReturnType<
      ExtractTheDefinedEndpoints<typeof dashboardApiEndpoints>["/companies/:company_id/developers/current"]["GET"]
    >
  >,
  TData = TFnData,
>(
  options?: GetUseQueryOptions<
    typeof dashboardApiEndpoints,
    "GET",
    "/companies/:company_id/developers/current",
    ExtractTheDefinedEndpoints<typeof dashboardApiEndpoints>["/companies/:company_id/developers/current"]["GET"],
    TFnData,
    TData
  >
) => {
  const {
    data: { _id: companyId },
  } = useCompany();
  return useDashboardApiQuery("/companies/:company_id/developers/current", {
    params: [companyId],
    options: {
      ...options,
    },
  });
};
